import React from "react";
import { convertAdUrl ,translateText} from "../../utils/utils";
import { useSelector } from "react-redux";
import Translate from "../Multilanguage/Translate";
import { updateContinueWatching } from "../../network/service";
import { ToastContainer, toast } from "react-toastify";


const RemoveFromContinueWatchModal = (props) => {
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const theme = projectInfo?.projectConfig?.config?.THEME; 

  const RemoveItemHandler = async (value) => {
    if (value === "yes") {
     handleRemoveContinueWatching(props?.data?.video_id)
    } else if (value === "no") {
     props?.setIsRemoving(false);
      if (props.onCancel) {
        props.onCancel(); 
      }
    }
  };
   const handleRemoveContinueWatching = async (videoId) => {
      props?.setIsRemoving(true);
        const response = await updateContinueWatching(props?.appInfo, videoId);
          if (response?.status === 200 ) {
          toast.success(<Translate textKey={'removed_from_continue_watching'}/>);
          if (props.onRemove) props.onRemove(videoId);
        } else {
          toast.error(<Translate textKey={'failed_to_remove'}/>);
        }
     
      props?.setIsRemoving(false);
    };
  return (
   
    <div className={`removeFromContinueWatchModal ${projectInfo?.projectConfig?.config?.TEMPLATE === 'TEMPLATE_12' ? 'kids' : ''}`}>
      <ToastContainer
          position="bottom-center"
          style={{ right: "30em", bottom: "5em" }}
        />
      <div className={`removeContents ${theme === 'LIGHT' ? 'light-theme' : ''}`}>
        <h1 className={`${theme === 'LIGHT' ? 'light-theme' : ''}`}><Translate textKey={'remove_list'} /></h1>
        <div className="buttons">
          <div
            className="buttonContainer"
            onClick={(e) => { e.stopPropagation(); RemoveItemHandler("yes"); }}
          >
            <div className="background"></div>
            <button className={`${theme === 'LIGHT' ? 'light-theme' : ''}`}><Translate textKey={'ok'} /></button>
          </div>

          <div
            className="buttonContainer"
            onClick={(e) => { e.stopPropagation(); RemoveItemHandler("no"); }}
          >
            <div className="background"></div>
            <button className={`${theme === 'LIGHT' ? 'light-theme' : ''}`}><Translate textKey={'cancel'} /></button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RemoveFromContinueWatchModal;
